import React from 'react';
import classNames from 'classnames';
import { Nav, NavItem, NavLink } from 'reactstrap';
import {FormattedMessage, injectIntl} from 'react-intl';
import PropTypes from 'prop-types';
import {messages} from  '../../common/Translations';
import {sectionsInfo, sectionsForFilterType} from './sectionsConfig';

class MetricsFilter extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.onItemChange = this.onItemChange.bind(this);
        this.state = {
            activeItem: 'documentPath',
        };
    }

    onItemChange(value) {
        this.props.onFilterChange(value);
        this.setState({
            activeItem: value,
        });
    }

    getLabel(value) {
        return this.props.labels[value];
    }

    getSectionItem(value) {
        return {value, label: this.getLabel(value)};
    }

    renderSection(title, items ) {
        const {
            eventType,
            analyticType,
        } = this.props;

        if(sectionsForFilterType[analyticType] && !~sectionsForFilterType[analyticType][eventType].indexOf(title)) {
            return null;
        }

        return <div key={title}>
            <p>{this.props.intl.formatMessage(messages[sectionsInfo[title].i18nId])}</p>
            <Nav vertical>
                {items.map((item, key) => {
                    return <NavItem key={key}>
                        <NavLink
                            onClick={(e => {this.onItemChange(item.value)})}
                            className={classNames('clickable', {
                                active: item.value === this.state.activeItem,
                                'font-weight-bold': item.value === this.state.activeItem,
                                'bg-faded': item.value === this.state.activeItem,
                                'text-primary': item.value !== this.state.activeItem,
                                'text-muted': item.value === this.state.activeItem,
                            })}
                        >
                            {item.label}
                        </NavLink>
                    </NavItem>
                })}
            </Nav>
            <hr/>
        </div>
    }

    render() {
        return (
            <div>
                {Object.keys(sectionsInfo).map(
                    sectionName => this.renderSection(sectionName, sectionsInfo[sectionName].items.map(
                        value => this.getSectionItem(value))
                    )
                )}
            </div>
        );
    }

    componentDidUpdate() {
        const {
            eventType,
            analyticType,
        } = this.props;

        const isActiveSectionItem = !sectionsForFilterType[analyticType] || sectionsForFilterType[analyticType][eventType].find(sectionName => {
            return ~sectionsInfo[sectionName].items.indexOf(this.state.activeItem);
        });

        if(!isActiveSectionItem) {
            const firstAvilableItem = sectionsInfo[sectionsForFilterType[analyticType][eventType][0]].items[0];
            this.onItemChange(firstAvilableItem);
        }
    }
}

MetricsFilter.propTypes = {
    eventType: PropTypes.oneOf(['pageview', 'click']).isRequired,
    analyticType: PropTypes.string.isRequired,
};

export default injectIntl(MetricsFilter);


// WEBPACK FOOTER //
// ./web/src/components/analytics/metrics/MetricsFilter.jsx